<template>
  <header class="k-nav">
    <a class="logo" href="/" aria-label="Viluu">
      <img :src="wordmark" alt="Viluu" width="86" height="24" />
    </a>
    <button type="button" class="btn-text" data-open-signup data-auth-mode="login">Einloggen</button>
  </header>
</template>

<script>
export default {
  name: 'KennenlernenNav',
  data() {
    return {
      wordmark: require('../../../../../images/viluu/landing-v2/viluu-wordmark.svg'),
    };
  },
};
</script>
